import { render } from "./HeroiconsSolidBookmarkAlt.vue?vue&type=template&id=d8b3f644"
const script = {}

import exportComponent from "/var/www/vacation-system/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidBookmarkAlt.vue"]])

export default __exports__